import { isNodeDevEnvironment } from '@repo/common';
import { isServer } from '@repo/ui/utils/is-server';

/**
 * SSR-aware development mode detection for React components.
 * On server: checks NODE_ENV === 'development'
 * On client: checks if hostname is localhost
 */
export function isDevMode(): boolean {
  if (isServer()) {
    return isNodeDevEnvironment();
  }
  return window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
}
